export default __webpack_public_path__ + "static/media/primary.6183149ff7430f5223d4002922f0a9ac.svg";